<template>
    <!-- banner section  -->
    <section class=" banner mt-4">
        <div class="container">
    <div class="bannerWrapper">
                <div class="d-block d-lg-flex no-gutters align-items-center h-100">
                    <div class="col-12 col-xl-8 col-lg-8 order-lg-1">

    </div> 
   <div id="home_banner_box" class="col-xl-5 col-lg-6 order-lg-0 h-100">
        <div class="spc-banner">
            <h2 class="h1 mb-20 text-white">All in One Farm Store</h2>
            <p class="text-white">Your Animal Needs in One Place.</p>

            <button class="btn btn-primary" @click="redirectproductlisting()">Shop Now</button>
        </div>
    </div>
    </div>
            </div>
    </div>
 </section>

    <section class="offerSect">
        <div class="container">
            <div class="row align-items-center">

                <!--WITHOUT SWIPER SLIDE-->
                <!--USE THIS ONE TO ACTIVE DYNAMIC BANNER-->

                <!--<div class="items banner1" v-for="(item,index) in bannervideo">
                     <img class="py-10 px-8 rounded offerCol overlayimg" v-if="$filters.IsNull(bannervideo[index],true,null)!=null" :src="bannervideo[index]" alt="slider_logo"  />
                      <div class="container">
                           <div class="contbx">
                              <h2 class="fw-bold mb-1">
                                <span v-if="description!=null && description!=''" v-html="description[0][index]"></span>
                              </h2>
                           </div>
                      </div>
                </div>-->

                <!--WITH SWIPER SLIDE-->

                <!--<section id="hero" class="d-flex justify-cntent-center align-items-center" v-if="$filters.IsNull(CompanyDynamicContent,true,null)!=null && CompanyDynamicContent.bannerType == 'Image'">
        <swiper :breakpoints="{900:{ slidesPerView:1, } }"
                :slides-per-view="1"
                :space-between="30"
                :modules="modules"
                @swiper="onSwiper"
                :navigation="true"
                autoplay="autoplay"
                :pagination="{ type: clickable }"
                @slideChange="onSlideChange">
            <swiper-slide v-for="(item,index) in bannervideo">
                <div class="row">
                    <div class="col-12 col-md-12 col-lg-4 mb-3 mb-lg-0">
                        <div class="items banner1 py-10 px-8 rounded offerCol">
                            <img v-if="$filters.IsNull(bannervideo[index],true,null)!=null" :src="bannervideo[index]" alt="slider_logo" class="overlayimg" />
                            <div class="container">
                                <div class="contbx">
                                    <h2>
                                        <span v-if="description!=null && description!=''" v-html="description[0][index]"></span>
                                    </h2>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </swiper-slide>
        </swiper>

    </section>-->

                <!--STATIC-->

    <section class="offerSect">
        <div class="container">
            <div class="row align-items-center">
                <div class="col-12 col-md-12 col-lg-4 mb-3 mb-lg-0">


                    <div class="py-10 px-8 rounded offerCol div-offerSect-blogimage">
                        <div>
                            <h3 class="fw-bold mb-1">Apple and <br> Carrot</h3>
                            <p>
                                The Best Animal Feed Online!
                            </p>

                        </div>
                    </div>
                </div>
                <div class="col-12 col-md-12 col-lg-4 mb-3 mb-lg-0">
                    <div class="py-10 px-8 rounded offerCol div-offerSect-newsimage">
                        <div>
                            <h3 class="fw-bold mb-1">Hay</h3>
                            <p>The Best Animal Feed Online!</p>
                        </div>
                    </div>
                </div>
                <div class="col-12 col-md-12 col-lg-4 mb-3 mb-lg-0">
                    <div class="py-10 px-8 rounded offerCol div-offerSect-Testimonialsimage">
                        <div>
                            <h3 class="fw-bold mb-1">Grass Feed</h3>
                            <p>The Best Animal Feed Online!</p>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </section>
            </div>
        </div>
    </section>
    <section class="container ">
        <h2 class="heading text-center">Top Selling Products</h2>
        <div id="top_selling_Products" class="row pt-4 mx-n2">
            <div class="col-lg-3 col-md-6 col-sm-6 px-2 mb-4" v-for="(productitem,index) in ProductList">
                <div class="card product-card">
                    <!--<div class="discount-badge">
                        {{productitem.discount}}%
                    </div>-->
                    <a class="card-img-top d-block overflow-hidden" @click="ProductDetailpage(productitem.id)">
                        <img :src="productitem.imageUrl" height="350" alt="product">
                    </a>
                    <div class="card-body py-2">
                        <h3 class="product-title fs-sm">
                            <a @click="ProductDetailpage(productitem.id)">
                                {{productitem.productName}}
                            </a>
                        </h3>
                        <!--<div class="star-rating">
                            <i class="fa fa-star"></i>
                            <i class="fa fa-star"></i>
                            <i class="fa fa-star"></i>
                            <i class="fa fa-star"></i>
                            <i class="fa fa-star"></i>
                        </div>-->
                        <div class="product-price" v-if="productitem.price.toFixed(2) == productitem.salePrice.toFixed(2)">
                            ${{productitem.salePrice.toFixed(2)}}
                        </div>
                        <div class="product-price" v-else>
                            <del>${{productitem.price.toFixed(2)}}</del>
                            ${{productitem.salePrice.toFixed(2)}} <span class="discount-text-orange">({{productitem.discount}}% Off)</span>
                        </div>

                    </div>
                    <div class="card-body card-body-hidden d-flex">

                        <button v-if="productitem.availableStock > 0 " class="btn btn-primary btn-sm d-block w-100 mb-2" @click="Path(productitem.id)">
                            <i class="ci-cart fs-sm me-1"></i>Add to Cart
                        </button>

                        <button v-else class="btn btn-primary btn-sm d-block w-100 mb-2" disabled>
                            <i class="ci-cart fs-sm me-1"></i>Out Of Stock
                        </button>


                        <div class="text-center">
                            <a class="nav-link-style fs-ms" href="#quick-view" data-bs-toggle="modal" type="button" @click="ProductDetailpage(productitem.id)">
                                <i class="fa fa-eye"></i>
                            </a>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </section>
    <section id="featured_category" class="container cstm-mrgin">
        <h2 class="heading text-center">Featured Categories</h2>
        <div class="row pt-4 mx-n2" style="justify-content:center;">
            <!-- Product-->
            <div class="col-lg-3 col-md-6 col-sm-6 px-2 mb-4" v-for="(prodcatitem,index) in ProductCatgoryList">
                <div class="categorybx">
                    <a @click="productdetails(prodcatitem.id)">
                        <div class="catwrap"><img :src="prodcatitem.imageUrl" class="img-fluid" /></div>
                        <h3>{{prodcatitem.categoryName}}</h3>
                    </a>
                </div>
            </div>
            <!-- Product-->
            <!--<div class="col-lg-3 col-md-4 col-sm-6 px-2 mb-4">
                <div class="categorybx">
                    <a href="#">
                        <div class="catwrap"><img src="../assets/images/ranch.jpg" class="img-fluid" alt="ranch" /></div>
                        <h3>Ranch</h3>
                    </a>
                </div>
            </div>-->
            <!-- Product-->
            <!--<div class="col-lg-3 col-md-4 col-sm-6 px-2 mb-4">
                <div class="categorybx">
                    <a href="#">
                        <div class="catwrap"><img src="../assets/images/horse.jpg" class="img-fluid" alt="horse" /></div>
                        <h3>Horse</h3>
                    </a>
                </div>
            </div>-->
            <!-- Product-->
            <!--<div class="col-lg-3 col-md-4 col-sm-6 px-2 mb-4">
                <div class="categorybx">
                    <a href="#">
                        <div class="catwrap"><img src="../assets/images/paultry.jpg" class="img-fluid" alt="paultry" /></div>
                        <h3>Poultry</h3>
                    </a>
                </div>
            </div>-->
            <!-- Product-->
            <!--<div class="col-lg-3 col-md-4 col-sm-6 px-2 mb-4">
                <div class="categorybx">
                    <a href="#">
                        <div class="catwrap"><img src="../assets/images/feed-day.jpg" class="img-fluid" alt="feed-day" /></div>
                        <h3>Feed/Hay</h3>
                    </a>
                </div>
            </div>-->
            <!-- Product-->
            <!--<div class="col-lg-3 col-md-4 col-sm-6 px-2 mb-4">
                <div class="categorybx">
                    <a href="#">
                        <div class="catwrap"><img src="../assets/images/farm-feedday.jpg" class="img-fluid" alt="farm-feedday" /></div>
                        <h3>Farm</h3>
                    </a>
                </div>
            </div>-->
            <!-- Product-->
            <!--<div class="col-lg-3 col-md-4 col-sm-6 px-2 mb-4">
                <div class="categorybx">
                    <a href="#">
                        <div class="catwrap"><img src="../assets/images/lawn-garden.jpg" class="img-fluid" alt="lawn-garden" /></div>
                        <h3>Lawn & Garden</h3>
                    </a>
                </div>
            </div>-->
            <!-- Product-->
            <!--<div class="col-lg-3 col-md-4 col-sm-6 px-2 mb-4">
                <div class="categorybx">
                    <a href="#">
                        <div class="catwrap"><img src="../assets/images/outdoor-power.jpg" class="img-fluid" alt="outdoor-power" /></div>
                        <h3>Outdoor Power</h3>
                    </a>
                </div>
            </div>-->
        </div>
    </section>
    <section class="container ">
        <h2 class="heading text-center">Recommended For You</h2>
        <div class="row pt-4 mx-n2">
            <!-- Product-->
            <div class="col-lg-12">
                <div class="recommendProdct">
                    <div class="card product-card bg-grey" v-for="(prodcatitem,index) in RecommendedProductList">
                        <div class="discount-badge blank"></div>
                        <!--<div class="saving-badge">{{prodcatitem.discount}}%</div>-->
                        <a class="card-img-top d-block overflow-hidden" @click="ProductDetailpage(prodcatitem.id)">
                            <img :src="prodcatitem.imageUrl" height="300" alt="dog-house">
                        </a>
                        <div class="card-body py-2">
                            <h3 class="product-title fs-sm"><a @click="ProductDetailpage(prodcatitem.id)">{{prodcatitem.productName}}</a></h3>
                            <!--<div class="star-rating">
                                <i class="fa fa-star"></i>
                                <i class="fa fa-star"></i>
                                <i class="fa fa-star"></i>
                                <i class="fa fa-star"></i>
                                <i class="fa fa-star"></i>
                            </div>-->
                            <div class="product-price" v-if="prodcatitem.price.toFixed(2) == prodcatitem.salePrice.toFixed(2)">
                                ${{prodcatitem.salePrice.toFixed(2)}}
                            </div>
                            <div class="product-price" v-else>
                                <del>${{prodcatitem.price.toFixed(2)}}</del> ${{prodcatitem.salePrice.toFixed(2)}}
                                <span class="discount-text-orange">({{prodcatitem.discount}}% Off)</span>
                            </div>

                        </div>
                        <div class="card-body card-body-hidden d-flex">
                            <button class="btn btn-primary btn-sm d-block w-100 mb-2" v-if="prodcatitem.availableStock > 0" type="button" @click="Path(prodcatitem.id)">
                                <i class="ci-cart fs-sm me-1"></i>Add to Cart
                            </button>
                            <button v-else class="btn btn-primary btn-sm d-block w-100 mb-2" disabled>
                                <i class="ci-cart fs-sm me-1"></i>Out Of Stock
                            </button>

                            <div class="text-center">
                                <a class="nav-link-style fs-ms" href="#quick-view" data-bs-toggle="modal" type="button" @click="ProductDetailpage(prodcatitem.id)">
                                    <i class="fa fa-eye"></i>
                                </a>
                            </div>
                        </div>
                    </div>

                </div>
            </div>
        </div>
    </section>
    <section class="offerSect offersrow">
        <div class="container">
            <div class="row align-items-center">
                <div class="col-12 col-lg-6 col-md-12 mb-3 mb-lg-0">
                    <div class="py-10 px-8 rounded offerCol div-Animal-image">
                        <div>
                            <div class="cat-badge">Animal Care </div>
                            <h3 class="font-40 text-white fw-bold mt-4 mb-3">Advanced Veterinary <br>Dentistry</h3>
                            <p class="text-white"> Practice Limited to Veterinary Dentistry </p>
                            <!--<a href="#" class="btn btn-white">Shop Now</a>-->
                            <button class="btn btn-primary" @click="redirectproductlisting()">Shop Now</button>
                        </div>
                    </div>
                </div>
                <div class="col-12 col-lg-3 col-md-6 mb-3 mb-lg-0">
                    <div class="py-10 px-8 rounded offerCol smoffer mb-3 div-Pickup-image">
                        <div>
                            <h3 class="font-30  text-white fw-bold mb-1">Curbside Pickup</h3>
                            <p class="text-white"> Free Pick-up in Store </p>
                            <!--<a href="#" class="btn btn-white">Shop Now</a>-->
                            <button class="btn btn-primary" @click="redirectproductlisting()">Shop Now</button>
                        </div>
                    </div>
                    <div class="py-10 px-8 rounded offerCol smoffer div-Delivery-image">
                        <div>
                            <h3 class="font-30  fw-bold text-white mb-1">Local Delivery</h3>
                            <p class="text-white"> Same Day Delivery </p>
                            <!--<a href="#" class="btn btn-white">Shop Now</a>-->
                            <button class="btn btn-primary" @click="redirectproductlisting()">Shop Now</button>
                        </div>
                    </div>
                </div>
                <div class="col-12 col-lg-3 col-md-6 mb-3 mb-lg-0">
                    <div class="py-10 px-8 rounded offerCol div-sale-offer-image">
                        <div>
                            <p class="smHeading"> SALE </p>
                            <div class="perc"><b>20%</b> Off on</div>
                            <h3 class="lg-heading fw-bold mb-1">Equine</h3>
                            <p class="prod"> Products </p>
                            <!--<a href="#" class="btn btn-white">Shop Now</a>-->

                            <button class="btn btn-primary" @click="redirectproductlisting()">Shop Now</button>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </section>
    <!--<section class="container superSaving">
        <h2 class="heading text-center mb-3">Top Saver Today</h2>-->
    <!--<div id="countdown">
        <ul>
            <li>Expires in:</li>
            <li class="hide"><span id="days"></span>days</li>
            <li><span id="hours"></span> : </li>
            <li><span id="minutes"></span> : </li>
            <li><span id="seconds"></span></li>
        </ul>
    </div>-->
    <!--<div class="row mt-4">
        <div class="col-lg-9 col-md-7">
            <div class="row ">-->
    <!-- Product-->
    <!--<div class="col-lg-3 col-md-6 col-sm-6 px-2 mb-4" v-for="(prodcatitem,index) in SaverTodayProductList">
        <div class="card product-card">-->
    <!--<div class="saving-badge">{{prodcatitem.discount}}%</div>-->
    <!--<a class="card-img-top d-block overflow-hidden" @click="ProductDetailpage(prodcatitem.id)">
        <img :src="prodcatitem.imageUrl" height="350" alt="product">
    </a>
    <div class="card-body py-2">
        <h3 class="product-title fs-sm"><a @click="ProductDetailpage(prodcatitem.id)">{{prodcatitem.productName}}</a></h3>-->
    <!--<div class="star-rating">
        <i class="fa fa-star"></i>
        <i class="fa fa-star"></i>
        <i class="fa fa-star"></i>
        <i class="fa fa-star"></i>
        <i class="fa fa-star"></i>
    </div>-->
    <!--<div class="product-price"><del>${{prodcatitem.price.toFixed(2)}}</del> ${{prodcatitem.salePrice.toFixed(2)}} <span class="discount-text-green">({{prodcatitem.discount}}% Off)</span></div>

            </div>
            <div class="card-body card-body-hidden">
                <button class="btn btn-primary btn-sm d-block w-100 mb-2" v-if="prodcatitem.availableStock > 0" type="button" @click="Path(prodcatitem.id)">
                    <i class="ci-cart fs-sm me-1"></i>Add to Cart
                </button>
                <button v-else class="btn btn-primary btn-sm d-block w-100 mb-2" disabled>
                    <i class="ci-cart fs-sm me-1"></i>Out Of Stock
                </button>
                <div class="text-center">
                    <a class="nav-link-style fs-ms" href="#quick-view" data-bs-toggle="modal" type="button" @click="ProductDetailpage(prodcatitem.id)">
                        <i class="fa fa-eye"></i>
                    </a>
                </div>
            </div>
        </div>
    </div>-->
    <!-- Product-->
    <!--</div>
            </div>
            <div class="col-lg-3 col-md-5">
                <img class="img-fluid" src="../assets/images/black-friday.png" alt="black-friday" />
            </div>
        </div>
    </section>-->
    <section class="offerSect ranchmap">
        <div class="container">
            <div class="row align-items-center">
                <div class="col-12 col-md-12 mb-3 mb-lg-0">
                    <div class="py-10 px-8 rounded offerCol div-sale-ranchmap-image">
                        <div>
                            <div class="tag-badge">Ranch Map</div>
                            <h2 class="sub-heading text-white fw-bold mb-1">
                                Picking Fruits & Farm Day
                            </h2>
                            <p class="text-white"> More Than 500+ Items </p>
                            <button class="btn btn-white" @click="redirectproductlisting()">Shop Now</button>

                            <!--<a href="#" class="btn btn-white">Shop Now</a>-->
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </section>
    <section class="service-area">
        <div class="container">
            <div class="row row-cols-xl-4 row-cols-sm-2 row-cols-1 row--20">
                <div class="col">
                    <div class="service-box service-style-2">
                        <div class="icon"><img alt="Thumbnail" src="../assets/images/service-icon1.png"></div>
                        <div class="content">
                            <h6 class="title">Free Pick-up in Store</h6>
                            <p>1 hour or less*</p>
                        </div>
                    </div>
                </div>
                <div class="col">
                    <div class="service-box service-style-2">
                        <div class="icon"><img alt="Thumbnail" src="../assets/images/service-icon2.png"></div>
                        <div class="content">
                            <h6 class="title">Same Day Delivery</h6>
                            <p>Buy it today. Get it today with same day delivery.</p>
                        </div>
                    </div>
                </div>
                <div class="col">
                    <div class="service-box service-style-2">
                        <div class="icon"><img alt="Thumbnail" src="../assets/images/service-icon3.png"></div>
                        <div class="content">
                            <h6 class="title">Financing Available</h6>
                            <p>Calculate your payment today.</p>
                        </div>
                    </div>
                </div>
                <div class="col">
                    <div class="service-box service-style-2">
                        <div class="icon"><img alt="Thumbnail" src="../assets/images/service-icon4.png"></div>
                        <div class="content">
                            <h6 class="title">Neighbor's Club </h6>
                            <p>Earn points with purchases.</p>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </section>
    <!--<section class=" bg-grey newlsetter">
        <div class="container">
            <div class="row align-items-center">
                <div class="col-lg-4 col-md-6">
                    <div class="newlsetterLogo">
                        <img alt="Site Logo" src="../assets/images/logo.png" />
                        <p>Easy and trusted online shop in US.</p>
                    </div>
                </div>
                <div class="col-lg-4 col-md-6">
                    <div class="newsletter_form">
                        <form>
                            <input type="text" required="" class="form-control rounded-0" placeholder="Enter Email Address">
                            <button type="submit" class="btn btn-dark rounded-0" name="submit" value="Submit">Subscribe</button>
                        </form>
                    </div>
                </div>
                <div class="col-lg-4 col-md-12">
                    <div class="social">
                        <h3>Follow us on</h3>
                        <a href="#"><i class="fa-brands fa-instagram"></i></a>
                        <a href="#"><i class="fa-brands fa-facebook"></i></a>
                        <a href="#"><i class="fa-brands fa-youtube"></i></a>
                    </div>
                </div>
            </div>
        </div>
    </section>-->
    <!-- hero area -->
    <!--<section class="hero-section hero">
        <div class="container">
            <div class="row">
                <div class="col-lg-12 text-center zindex-1">
                    <h1 class="mb-3">Intuitive and Powerful <br><span>Software to Manage High-Value Assets.</span></h1>
                    <p class="mb-4">zorbis is a web-based system that offers solutions for managing various assets, including vacation homes, yachts, apartments, chartered planes, storage units, and more.</p>
                    <router-link to="/requestdemo">
                        <a href="#" class="btn btn-outline btn-lg radius-btn mr-3">Request a Demo</a>
                    </router-link>
                    <router-link to="/pricing" class="btn btn-secondary btn-lg radius-btn">Buy Now </router-link>-->
    <!-- banner image -->
    <!--</div>
            </div>
        </div>
        <img class="img-fluid w-100 banner-image" src="../assets/images/banner.png" alt="banner-img">
    </section>-->
    <!-- /hero-area -->
    <!-- feature -->
    <!--<section class="section feature mb-0" id="feature">
        <div class="container-fluid">
            <div class="row">
                <div class="col-lg-12 text-center">
                    <h2 class="section-title mb-0" style="color: #0a5f43;">Manage it all with zorbis</h2>
                    <p class="mb-40">Zorbis can help you capitalize on your assets.</p>
                </div>-->
    <!-- feature item -->
    <!--<div class="col-lg-3 col-md-6 mb-3">
        <div class="item">
            <a href="#0" aria-labelledby="person1"></a>
            <img src="../assets/images/vacationhome.jpg" alt="vacationhome" class="img-fluid" />
            <div class="item__overlay">
                <h3 id="person1" aria-hidden="true">Vacation Home</h3>
                <div class="item__body">
                    <p>Browse vacation homes, beach houses, apartments, condos, house boats, castles, farm stays - and everything in between.</p>
                </div>
            </div>
        </div>
    </div>-->
    <!-- feature item -->
    <!--<div class="col-lg-3 col-md-6 mb-3">
        <div class="item">
            <a href="#0" aria-labelledby="person2"></a>
            <img src="../assets/images/yacht.jpg" alt="yacht" class="img-fluid" />
            <div class="item__overlay">
                <h3 id="person2" aria-hidden="true">Yacht</h3>
                <div class="item__body">
                    <p> Wherever you want to go in the world, and whatever type of yacht charter you're looking for, we have your perfect sailing vacation.</p>
                </div>
            </div>
        </div>
    </div>-->
    <!-- feature item -->
    <!--<div class="col-lg-3 col-md-6 mb-3">
                    <div class="item">
                        <a href="#0" aria-labelledby="person3"></a>
                        <img src="../assets/images/aircraft.jpg" alt="aircraft" class="img-fluid" />
                        <div class="item__overlay">
                            <h3 id="person3" aria-hidden="true">Aircraft</h3>
                            <div class="item__body">
                                <p>Whether it's for a luxury escape, a business trip or a critical emergency, we offer a range of private charter solutions to match your unique requirements.</p>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="col-lg-3 col-md-6 mb-3">
                    <div class="item">
                        <a href="#0" aria-labelledby="person4"></a>
                        <img src="../assets/images/storage-unit.jpg" alt="storage-unit" class="img-fluid" />
                        <div class="item__overlay">
                            <h3 id="person4" aria-hidden="true">Storage Unit</h3>
                            <div class="item__body">
                                <p>Whether you are looking to store a few items or plan to pack up a house, we have you covered.</p>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </section>-->
    <!-- /feature -->
    <!-- service -->
    <!--<section class="section-lg service">
        <div class="container">
            <div class="row justify-content-between align-items-center">
                <div class="col-lg-12 text-center">
                    <h2 class="section-title mb-80">I'm interested in a solution that can automate the management of both assets and services.</h2>
                </div>
                <div class="col-md-7 order-2 order-md-1 pr-50 mb-spc">
                    <h6 class="small-txt">CRM</h6>
                    <h2 class="section-title">Acquire new leads with<br> Minimal effort</h2>
                    <p class="mb-4">Our solution is designed to be simple, consistent, and reliable. It helps you acquire new leads, organize customer records, and trigger the following actions to move people effortlessly through the sales process.</p>
                    <a href="#" class="link">Learn More</a>
                </div>
                <div class="col-md-5 order-1 order-md-2">
                    <img class="img-fluid layer-3" src="../assets/images/crm.png" alt="crm">
                </div>
            </div>
        </div>
    </section>-->
    <!-- /service -->
    <!-- marketing -->
    <!--<section class="section-lg pt-0 pb-0 service">
        <div class="container">
            <div class="row  align-items-center">
                <div class="col-md-5">
                    <div class="seo-image">
                        <img class="img-fluid" src="../assets/images/ticketing.png" alt="ticketing">
                    </div>
                </div>
                <div class="col-md-7  pl-50 mb-spc">
                    <h6 class="small-txt">Ticketing</h6>
                    <h2 class="section-title">Manage all your service requests in one place</h2>
                    <p>BeeNee leverages advanced rules, automation, and multichannel capabilities to handle each ticket efficiently. Our system allows you to track ticket traffic, monitor customer satisfaction, and stay on top of unassigned tickets from a dedicated, easy-to-use dashboard.</p>
                    <a href="#" class="link">Learn More</a>
                </div>
            </div>
        </div>
    </section>-->
    <!-- /marketing -->
    <!-- service -->
    <!--<section class="section-lg service">
        <div class="container">
            <div class="row justify-content-between align-items-center">
                <div class="col-md-7 order-2 order-md-1  pr-50 mb-spc">
                    <h6 class="small-txt">Loan Portal</h6>
                    <h2 class="section-title">Streamline Your Loan and Lease Management Process</h2>
                    <p class="mb-4">Our loan management solution is designed to be user-friendly, flexible, and customizable to fit seamlessly into your workflow. Zorbis can also help with financing your assets, providing your customers a positive experience while effectively managing loans.</p>
                    <a href="#" class="link">Learn More</a>
                </div>
                <div class="col-md-5 order-1 order-md-2">
                    <img class="img-fluid layer-3" src="../assets/images/localportal.png" alt="localportal">
                </div>
            </div>
        </div>
    </section>-->
    <!-- /service -->
    <!-- marketing -->
    <!--<section class="section-lg pt-0 service">
        <div class="container">
            <div class="row align-items-center">
                <div class="col-md-5">
                    <div class="seo-image">
                        <img class="img-fluid" src="../assets/images/vacation-img.png" alt="vacationhome">
                    </div>
                </div>
                <div class="col-md-6 pl-50 mb-spc">
                    <h6 class="small-txt">Vacation Management</h6>
                    <h2 class="section-title">Let's connect and We'll Take Care of Your Home</h2>
                    <p>At BeeNee, we take great pride in providing our members with superior services. When you need optimal-scheduling for a multi-owner property, Zorbis's AI driven scheduling can be the most-effective tool for you.</p>
                    <a href="#" class="link">Learn More</a>
                </div>
            </div>
        </div>
    </section>-->
    <!-- /marketing -->
    <!-- team -->
    <!--<section class="section-lg team manageEverything pb-0" id="team">
        <div class="container-fluid">
            <div class="row">
                <div class="col-lg-12 text-center">
                    <h2 class="section-title mb-80">BeeNee mobile app to <br> Manage everything, anytime, anywhere</h2>
                </div>
            </div>
            <div class=" row">
                <div class="team-slider">
                    <swiper :modules="modules"
                            :slides-per-view="5"
                            :space-between="0"
                            :centeredSlides="true"
                            :loop=true
                            :pagination="{ enabled:true,clickable: true}"
                            :scrollbar="{ draggable: true }"
                            :breakpoints="{ 480:{ slidesPerView:1 }, 600:{ slidesPerView:1.7 }, 900:{ slidesPerView:2.5, } }"
                            :autoplay="{ delay: 5000,disableOnInteraction: false,waitForTransition:true}">
                        <swiper-slide>
                            <div class="team-member">
                                <img src="../assets/images/mobile1.png" alt="mobile1" class="img-fluid" />
                            </div>
                        </swiper-slide>
                        <swiper-slide>
                            <div class="team-member">
                                <img src="../assets/images/mobile2.png" alt="mobile1" class="img-fluid" />
                            </div>
                        </swiper-slide>
                        <swiper-slide>
                            <div class="team-member">
                                <img src="../assets/images/mobile0.png" alt="mobile1" class="img-fluid" />
                            </div>
                        </swiper-slide>
                        <swiper-slide>
                            <div class="team-member">
                                <img src="../assets/images/mobile1.png" alt="mobile1" class="img-fluid" />
                            </div>
                        </swiper-slide>
                        <swiper-slide>
                            <div class="team-member">
                                <img src="../assets/images/mobile2.png" alt="mobile1" class="img-fluid" />
                            </div>
                        </swiper-slide><swiper-slide>
                            <div class="team-member">
                                <img src="../assets/images/mobile1.png" alt="mobile1" class="img-fluid" />
                            </div>
                        </swiper-slide>
                        <swiper-slide>
                            <div class="team-member">
                                <img src="../assets/images/mobile2.png" alt="mobile1" class="img-fluid" />
                            </div>
                        </swiper-slide>
                        <swiper-slide>
                            <div class="team-member">
                                <img src="../assets/images/mobile0.png" alt="mobile1" class="img-fluid" />
                            </div>
                        </swiper-slide>
                        <swiper-slide>
                            <div class="team-member">
                                <img src="../assets/images/mobile1.png" alt="mobile1" class="img-fluid" />
                            </div>
                        </swiper-slide>
                        <swiper-slide>
                            <div class="team-member">
                                <img src="../assets/images/mobile2.png" alt="mobile1" class="img-fluid" />
                            </div>
                        </swiper-slide>   <swiper-slide>
                            <div class="team-member">
                                <img src="../assets/images/mobile2.png" alt="mobile1" class="img-fluid" />
                            </div>
                        </swiper-slide>
                    </swiper>
                </div>
                <div class="mobile-transparent"></div>
            </div>
        </div>
    </section>-->
    <!-- /team -->
    <!-- marketing -->
    <!--<section class="section-lg  getStarted">
            <div class="container">
                <div class="row align-items-center">
                    <div class="col-lg-6 col-md-12">
                        <ul class="content-list">
                            <li>
                                <h4>Centralized</h4>
                                <p>Know the status of all assets at one glance and perform lease operations.</p>
                            </li>
                            <li>
                                <h4>Automate Rents</h4>
                                <p>BeeNee makes it easy to stay on top of critical financial data, such as interest rates, expenses, and rental income. Our platform also lets you keep digital copies of all your receipts, ensuring you are prepared for upcoming Tax regulations.</p>
                            </li>
                            <li>
                                <h4>Taxes & Finances</h4>
                                <p>With BeeNee, connecting to your bank is effortless. In just a few seconds, you can easily link your account and eliminate the risk of human error. Instead of manual data entry and enjoy painless record-keeping with Zorbis.</p>
                            </li>
                        </ul>
                    </div>
                    <div class="col-lg-1 col-md-12"></div>
                    <div class="col-lg-5 col-md-12">
                        <div class="getStartedbx">
                            <h4>Let's get started!</h4>
                            <p>Talk with an expert and see BeeNee in action.</p>
                            <Form autocomplete="off" @submit="onSubmit" :validation-schema="schema" v-slot="{ errors }" class="row gx-3">
                                <div class="getStartedbx-Frm row">
                                    <div class="col-md-6">
                                        <div class="form-group">
                                            <Field type="text" name="firstname" v-model="firstname"
                                                   :class="{ 'form-control' : true ,'is-invalid': errors.firstname }"
                                                   maxlength="50" placeholder="First Name*" />
                                            <div class="invalid-feedback">{{errors.firstname
        }}
    </div>
                                        </div>
                                    </div>
                                    <div class="col-md-6">
                                        <div class="form-group">
                                            <Field type="text" name="lastname" v-model="lastname"
                                                   :class="{ 'form-control' : true ,'is-invalid': errors.lastname }"
                                                   maxlength="50" placeholder="Last Name*" />
                                            <div class="invalid-feedback">{{errors.lastname}}</div>
                                        </div>
                                    </div>
                                    <div class="col-md-12">
                                        <div class="form-group">
                                            <Field type="text" name="email" v-model="contactusData.email"
                                                   :class="{ 'form-control' : true ,'is-invalid': errors.email }"
                                                   maxlength="50" placeholder="Work Email*" />
                                            <div class="invalid-feedback">{{errors.email}}</div>
                                        </div>
                                    </div>
                                    <div class="col-md-6">
                                        <div class="form-group">
                                            <Field v-slot="{field }"
                                                   v-model="contactusData.phone"
                                                   name="phone"
                                                   value="value">

                                                <input-mask name="phone"
                                                            v-model="contactusData.phone"
                                                            :model-value="field.value"
                                                            mask="(999) 999-9999"
                                                            :class="{ 'form-control' : true ,'is-invalid': errors.phone }"
                                                            placeholder="(___) ___-____"
                                                            type="text"></input-mask>
                                                <div class="invalid-feedback">{{errors.phone}}</div>
                                            </Field>
                                        </div>
                                    </div>
                                    <div class="col-md-6">
                                        <div class="form-group">
                                            <Field type="text" name="companyname" v-model="contactusData.companyname"
                                                   :class="{ 'form-control' : true ,'is-invalid': errors.companyname }"
                                                   maxlength="50" placeholder="Company Name*" />
                                            <div class="invalid-feedback">{{errors.companyname}}</div>
                                        </div>
                                    </div>
                                    <div class="col-md-12">
                                        <div class="form-group">
                                            <Field type="text" v-model="contactusData.subject" name="subject"
                                                   :class="{ 'form-control' : true ,'is-invalid': errors.subject }"
                                                   placeholder="Subject*" />
                                            <div class="invalid-feedback">{{errors.subject}}</div>
                                        </div>
                                    </div>
                                    <div class="col-md-12">
                                        <div class="form-group">
                                            <Field name="message" v-model="contactusData.message">
                                                <textarea v-model="contactusData.message"
                                                          :class="{ 'form-control' : true ,'is-invalid': errors.message }"
                                                          placeholder="Message*" />
                                            </Field>
                                            <div class="invalid-feedback">{{errors.message}}</div>
                                        </div>
                                    </div>-->
    <!--<div class="col-md-12">
        <select class="form-control mb-3">
            <option>Country</option>
        </select>
    </div>-->
    <!--<div class="col-md-12">
                                    <button type="submit" class="btn btn-secondary">Get Demo</button>
                                </div>
                            </div>
                        </Form>
                    </div>
                </div>
            </div>
        </div>

    </section>-->
    <!-- /marketing -->
    <!-- marketing -->
    <!--<section class="section-lg testimonial">
        <div class="container-fluid">
            <div class="row align-items-center">
                <div class="col-lg-12 text-center">
                    <h2 class="section-title mb-0" style="color: #0a5f43;">Hear from our Customers</h2>
                    <p class="mb-40">What sets BeeNee as all in one solution for you </p>
                </div>

                <div class="testimonialSlide" id="testSlide1">

                    <swiper :modules="modules"
                            :slides-per-view="3"
                            :space-between="0"
                            loop=true
                            :autoplay="{delay: 3000,disableOnInteraction: false}"
                            :scrollbar="{ draggable: true }">
                        <swiper-slide v-for="(testimonial,index) in testimonailList">

                            <div class="slide">
                                <div class="slide-flex reverse">
                                    <div class="slide-col" data-toggle="modal" href="#videoTest"><img src="../assets/images/testimonial.jpg" alt="testimonial" class="img-fluid" /></div>
                                    <div class="slide-col">
                                        <div :class="(index%2==0)?'testimonialbx gold h-100':'testimonialbx h-100'">
                                            <p class="testimonial-quote">{{$filters.TruncateStr( testimonial.description,150)}}</p>
                                            <p class="testimonial-author"><b>{{testimonial.authorname}}<br> {{$filters.dateFormat(testimonial.posteddate)}}</b></p>
                                        </div>
                                    </div>
                                </div>
                            </div>

                        </swiper-slide>
                    </swiper>
                </div>


                <div class="modal fade videotest" id="videoTest" tabindex="-1" role="dialog" aria-labelledby="exampleModalLabel" style="display: none;" aria-hidden="true">
                    <div class="modal-dialog" role="document">
                        <div class="modal-content">
                            <div class="modal-body">
                                <button type="button" class="close" data-dismiss="modal" aria-label="Close">
                                    <span aria-hidden="true">x</span>
                                </button>

                                <iframe src="https://www.youtube.com/embed/ppawFI1u6Po" width="100%" height="317" frameborder="0" allow="accelerometer; autoplay; encrypted-media; gyroscope; picture-in-picture" allowfullscreen=""></iframe>

                            </div>

                        </div>
                    </div>
                </div>-->
    <!--<div class="testimonialSlide" id="testSlide2">
        <swiper :modules="modules"
                :slides-per-view="3"
                :space-between="0"
                loop=true
                :scrollbar="{ draggable: true }"
                :autoplay="{ delay: 3000,disableOnInteraction: false,waitForTransition:true,reverseDirection:true}">
            <swiper-slide v-for="(testimonial,index) in testimonailList">
                <div class="slide">
                    <div class="slide">
                        <div class="slide-flex reverse">
                            <div class="slide-col" data-toggle="modal" href="#videoTest"><img src="../assets/images/testimonial.jpg" alt="testimonial" class="img-fluid" /></div>
                            <div class="slide-col">
                                <div :class="(index%2!=0)?'testimonialbx gold h-100':'testimonialbx h-100'">
                                    <p class="testimonial-quote">{{$filters.TruncateStr( testimonial.description,150)}}</p>
                                    <p class="testimonial-author"><b>{{testimonial.authorname}}<br> {{$filters.dateFormat(testimonial.posteddate)}}</b></p>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </swiper-slide>
        </swiper>
    </div>-->
    <!--</div>
        </div>

    </section>-->
    <!-- /marketing -->
    <!-- newsletter -->
    <!--<section class="newsletter">
        <div class="container">
            <div class="row align-items-center">
                <div class="col-lg-6">
                    <h4>Do you want to subscribe our newsletter?<br> Leave your email and will keep you updated</h4>
                </div>
                <div class="col-lg-6">
                    <Form autocomplete="off" @submit="emailsubmit" :validation-schema="schemaemail" v-slot="{ errors }" class="gx-3">
                        <div class="row">
                            <div class="col-lg-12">
                                <label class="newsletter-label"> Your Email</label>
                                <div class="input-wrapper position-relative">
                                    <div class="input-wrapper-box">
                                        <Field type="text" name="email" v-model="emailvalue"
                                               :class="{ 'is-invalid': errors.email }"
                                               class="form-control" maxlength="50" placeholder="Enter your email" />
                                        <div class="invalid-feedback">{{errors.email}}</div>
                                    </div>
                                    <input type="submit" class="btn newsletter-btn" />
                                </div>
                            </div>
                        </div>
                    </Form>
                </div>
            </div>
        </div>-->
    <!-- background shapes -->
    <!--</section>-->
    <Loading v-model:active="isLoading">
    </Loading>

    <!--<Header  @Search="Search" :Headerpage="Headerpage"></Header>-->
</template>

<script>
    import { Swiper, SwiperSlide } from 'swiper/vue';
    import { Form, Field } from 'vee-validate';
    import { Pagination, Navigation, Scrollbar, Autoplay } from 'swiper';
    import 'swiper/css/pagination';
    import 'swiper/css/navigation';
    import 'swiper/css/virtual';
    import service from '@/service/FrontendService.js'
    import * as Yup from 'yup';
    import InputMask from "@/views/shared/inputmask/inputmasktemplate.vue"
    import ECommerce from '@/service/ECommerce.js';
    /*    import Header from "../Layout/header/Header.vue"*/
    // Import Swiper styles
    import 'swiper/css';
    /*   import eventBus from './event-bus';*/

    export default {
        name: 'HomeView',
        components: {
            Form, Field, InputMask,
            Swiper,
            SwiperSlide,
            /*Header*/
        },
        props: ['homes', 'searchValue'],
        data() {
            const companyId = localStorage.getItem("SupcompanyId")
            const schema = Yup.object().shape({
                firstname: Yup.string().required('First name is required'),
                lastname: Yup.string().required('Last name is required'),
                phone: Yup.string().required('Phone is required'),
                companyname: Yup.string().required('Company Name is required'),
                subject: Yup.string().required('Subject is required'),
                message: Yup.string().required('Message is required'),
                email: Yup.string().required('Email is required').email('Email is invalid').matches('^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\\.[a-zA-Z]{2,4}$', 'Email is invalid'),
            });
            const schemaemail = Yup.object().shape({
                email: Yup.string().required('Email is required').email('Email is invalid').matches('^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\\.[a-zA-Z]{2,4}$', 'Email is invalid'),
            });
            return {
                modules: [Pagination, Navigation, Scrollbar, Autoplay],
                schema,
                schemaemail,
                firstname: '',
                lastname: '',
                contactusData: {
                    id: null,
                    name: '',
                    companyname: '',
                    email: null,
                    phone: '',
                    subject: '',
                    message: '',
                    type: '',
                    companyId: localStorage.getItem("SupcompanyId")
                },

                ProductCatgoryList: null,
                //TopProductCatgoryList: null,
                ProductList: '',
                RecommendedProductList: [],
                SaverTodayProductList: [],
                emailvalue: null,
                isLoading: true,
                isMarketPlace: true,
                IsFeateured: true,
                IsFeateureds: false,
                companyId,

                id: null,
                search: '',
                Headerpage: true,
                searchproduct: '00Test',
                CompanyDynamicContent: [],
                bannervideo: [],
                description: [],
            }
        },
        created() {
            //
            //         this.$bus.on('data-event', (data) => {
            //  this.receivedData = data;


            //});

            if (this.searchValue != null || this.searchValue != undefined) {
                this.searchproduct = this.searchValue;;
                this.$emit("Homesss");
            }

            this.isLoading = false;
            this.GetProductList();
            this.GetProductCatgoryList();
            this.GetSaverTodayProductList();
            this.GetRecommendedProductList();
            this.GetDynamicContent();
            (function () {
                const second = 1000,
                    minute = second * 60,
                    hour = minute * 60,
                    day = hour * 24;

                //I'm adding this section so I don't have to keep updating this pen every year :-)
                //remove this if you don't need it
                let today = new Date(),
                    dd = String(today.getDate()).padStart(2, "0"),
                    mm = String(today.getMonth() + 1).padStart(2, "0"),
                    yyyy = today.getFullYear(),
                    nextYear = yyyy + 1,
                    dayMonth = "09/30/",
                    birthday = dayMonth + yyyy;

                today = mm + "/" + dd + "/" + yyyy;
                if (today > birthday) {
                    birthday = dayMonth + nextYear;
                }
                //end

                const countDown = new Date(birthday).getTime(),
                    x = setInterval(function () {

                        const now = new Date().getTime(),
                            distance = countDown - now;



                        //document.getElementById("days").innerText = Math.floor(distance / (day)),
                        //    document.getElementById("hours").innerText = Math.floor((distance % (day)) / (hour)),
                        //    document.getElementById("minutes").innerText = Math.floor((distance % (hour)) / (minute)),
                        //    document.getElementById("seconds").innerText = Math.floor((distance % (minute)) / second);

                        ////do something later when date is reached
                        //if (distance < 0) {
                        //    document.getElementById("headline").innerText = "It's my birthday!";
                        //    document.getElementById("countdown").style.display = "none";
                        //    document.getElementById("content").style.display = "block";
                        //    clearInterval(x);
                        //}
                        //seconds
                    }, 0)
            }())

        },

        updated() {
            window.scrollTo(0, 0);
        },
        mounted() {
            //
            this.$route.params
        },
        methods: {

            GetDynamicContent() {
                debugger;
                ECommerce.GetDynamicContentForComapny(localStorage.getItem("companyId")).then(res => {
                    debugger;
                    this.CompanyDynamicContent = res.data;
                    console.log('nghj', res.data);
                    debugger;
                    this.bannervideo = this.CompanyDynamicContent.bannerVideoLink.split(',');
                    console.log(" this.bannervideo this.bannervideo this.bannervideo this.bannervideo", this.bannervideo);
                    if (this.CompanyDynamicContent.description != null) {
                        this.description.push(this.CompanyDynamicContent.description.split('</p>,'));
                        console.log(" this.description this.description this.description this.description", this.description);
                    }
                    else {
                        this.description = null
                    }
                    //console.log('nghj', this.tittle);
                    const favicon = document.getElementById("favicon");
                    favicon.href = this.CompanyDynamicContent.favIconLink;
                    this.$parent.$parent.FooterLogoDescription = res.data.footerContent
                })
            },
            headerfalse() {
                //
                this.hom = false;;
            },
            Search(value) {


                this.search = value
            },
            GetProductList() {
               // debugger
                this.isLoading = true;
                this.IsFeateured = false;
                this.companyId = '00Test'
                this.searchproduct = (this.searchproduct == null) ? '00Test' : this.searchproduct;

                ECommerce.GetProductListhomeHeader(this.isMarketPlace, this.IsFeateureds, this.companyId, this.searchproduct).then((response) => {

                    if (this.$filters.IsNull(response.data) != null) {
                        console.log('data', response.data);
                        this.ProductList = null;;
                        this.ProductList = response.data
                    }
                    this.isLoading = false;
                }).catch((error) => {
                    this.isLoading = false;
                })
            },
            GetRecommendedProductList() {

                this.isLoading = true;
                this.IsFeateured = false;
                this.companyId = '00Test'
                ECommerce.GetRecommededProductListingFrontHome(this.isMarketPlace, this.IsFeateured, this.companyId, this.searchValue).then((response) => {

                    if (this.$filters.IsNull(response.data) != null) {
                        console.log('data', response.data);
                        this.RecommendedProductList = response.data;
                    }
                    this.isLoading = false;
                }).catch((error) => {
                    this.isLoading = false;
                })
            },
            GetSaverTodayProductList() {

                this.isLoading = true;
                this.IsFeateured = false;
                this.companyId = '00Test'
                ECommerce.GetSaverTodayProductListingHome(this.isMarketPlace, this.IsFeateured, this.companyId).then((response) => {

                    if (this.$filters.IsNull(response.data) != null) {
                        console.log('data', response.data);
                        this.SaverTodayProductList = response.data;
                    }
                    this.isLoading = false;
                }).catch((error) => {
                    this.isLoading = false;
                })
            },
            GetProductCatgoryList() {
              //  debugger
                this.isLoading = true;
                this.companyId = '00Test'
                this.IsFeateureds = true;
                ECommerce.GetProductCategoryListFront(this.isMarketPlace, this.IsFeateureds, this.companyId).then((response) => {

                    if (this.$filters.IsNull(response.data) != null) {
                        console.log('ProductCatgoryListdata', response.data);
                        this.ProductCatgoryList = response.data
                    }
                    this.isLoading = false;
                }).catch((error) => {
                    this.isLoading = false;
                })
            },
            productdetails(Id) {
                this.$router.push({ path: `/Products/${Id}` })
            },

            redirectproductlisting() {
                //redirects to product page(all categories)
                this.$router.push({ path: `/ProductList` })
                // this.$router.push({ path: `/Products` })
            },
            onSubmit() {
                this.isLoading = true;
                this.contactusData.name = this.firstname + ' ' + this.lastname;
                this.contactusData.type = 'Request Demo';
                service.savecontactus(this.contactusData).then(res => {
                    this.isLoading = false;
                    if (res.data == 1) {
                        this.success('Your request has been submitted successfully. Our team will contact you soon.');
                        this.$router.push({
                            name: "thankyou",
                            state: {
                                routeMessage: {
                                    IsSuccess: true,
                                    displayMessage: 'Your request has been submitted successfully. Our team will contact you soon.'
                                }
                            }
                        });
                    }
                    else {
                        this.error('Something went wrong')
                    }
                }).catch(res => {
                    this.error("Something went wrong. Please contact site administrator.");
                    this.isLoading = false;
                })
            },
            ProductDetailpage(Id) {

                this.$router.push({ path: `/ProductDetail/${Id}` })
                //this.$router.push({ path: `/Products` }) -- static page
            },
            //ProductDetailSpeicfic() {
            //    this.$router.push({ path: `/ProductDetail` })
            //},
            Path(Id) {
                debugger
                  if (localStorage.getItem('userlogin') == "false") {
                     this.$router.push({ path: `/Login` })
                 }

                  else {

                      let subscriptionInfo = localStorage.getItem("SubscriptionDetails");
                      var subscriptiondata = JSON.parse(subscriptionInfo);
                      if (subscriptiondata != null) {
                          if (subscriptiondata.subscriptiontype != null || subscriptiondata.subscriptiontype != 'undefined') {
                              this.error("You cannot add more than one product in subscription!");
                              this.isLoading = false;
                              return;
                          }
                      }

                      localStorage.setItem('cartaction', 'cartcalc');
                       this.$router.push({ path: `/Cart/${Id}` })

                 }
                

            },
            //RedirectToCart() {
            //    this.$router.push({ path: `/Cart` })
            //},
            //async emailsubmit() {
            //    this.isLoading = true;
            //    var manageSubscribersModel = {
            //        email: this.emailvalue
            //    }
            //    await FrontendService.AddSubscriber(manageSubscribersModel).then(Response => {
            //        if (Response != null && Response.data.statusCode == 200 || Response.data.statusCode == 201) {
            //            this.isLoading = false;
            //            if (Response.data.statusCode == 200) {
            //                this.$router.push({
            //                    name: "thankyou",
            //                    state: {
            //                        routeMessage: {
            //                            IsSuccess: true,
            //                            displayMessage: 'You have successfully joined our subscriber list'
            //                        }
            //                    }
            //                }
            //                )
            //            }
            //            else {
            //                this.$router.push({
            //                    name: "thankyou",
            //                    state: {
            //                        routeMessage: {
            //                            Email: this.emailvalue,
            //                            IsSuccess: false,
            //                        }
            //                    }
            //                });
            //            }
            //        }
            //        else {
            //            this.isLoading = false;
            //            this.error('Bad req')
            //        }
            //    }).catch(res => {
            //        this.error("Something went wrong. Please contact site administrator.");
            //        this.isLoading = false;
            //    })
            //}
        }
    }
</script>

<style scoped>
</style>

